import React, {ReactElement, useEffect} from 'react';
import AppHeader from '../../../components/appbar/AppBar';
import {useHistory} from 'react-router-dom';
import {LOGIN_ROUTE_PATH} from '../../../routes/route-constants';
import {storeInformation} from '../../../redux/storeInformationSlice';
import {setPageName} from '../../../lib/tagmanager';
import {pageName} from '../../../lib/constants';
import {useAppSelector, useAppDispatch} from '../../../redux/hooks';

import {
  getStoreEmployeeInfo,
  setStoreInformation,
} from '../../../core/localstorage-data';
import {setEmployeeLoggedIn} from '../../../redux/globalSlice';
const EmployeeStoreLocation = (): ReactElement => {
  const navigate = useHistory();
  const employeeInfo = getStoreEmployeeInfo();
  const storeInformationData = useAppSelector(storeInformation);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (employeeInfo === null || storeInformationData.resultCode === '') {
      localStorage.clear();
      window.location.href = 'employeesignin';
    }
    setPageName(pageName.storeIdentificationPage);
  }, []);
  const storeLocationHandler = () => {
    setStoreInformation(storeInformationData);
    dispatch(setEmployeeLoggedIn(true));
    navigate.push(LOGIN_ROUTE_PATH);
  };
  return (
    <div className="h-full">
      <AppHeader bgColor="transparent" />
      <div className="py-4 px-8 top-spacing-ipad">
        <div className="grid place-items-center overflow-y-auto">
          <span className="font-roboto text-big text-center font-bold">
            Confirm store
          </span>
        </div>
        <div className="mt-2">
          <p className="text-sm  text-black_zero text-center text-opacity-50 font-roboto">
            You are currently mapped to.
          </p>
          <p className="text-sm text-black_zero text-center  font-roboto font-bold">
            {storeInformationData.store_name}
          </p>
          <p className="text-sm text-black_zero text-center text-opacity-50 font-roboto">
            Please click yes to continue
          </p>
        </div>
        <button
          className="w-full h-50 primary normal mt-6 text-white font-bold focus:outline-none"
          type="submit"
          onClick={storeLocationHandler}
          // disabled={isOTPNotFilled()}>
        >
          Yes
        </button>
      </div>
    </div>
  );
};

export default EmployeeStoreLocation;
